import React from 'react';

type Props = {
  id?: string;
  content: string;
};

export const HtmlContent = ({ content, id }: Props) => (
  <div
    id={id}
    className="reas-html-content"
    dangerouslySetInnerHTML={{ __html: content }}
  />
);
